import { Injectable } from '@angular/core';
import { AngularFireMessaging } from '@angular/fire/compat/messaging';
import { BehaviorSubject } from 'rxjs';
import { environment } from "../../../environments/environment";
import { TranslateService } from "@ngx-translate/core";
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FirebaseMessagingService {
  token: string | null = null;
  permissionRequested: boolean = false;

  foregroundMessageData: BehaviorSubject<any> = new BehaviorSubject(null);
  currentLanguage: string = '';

  constructor(
    private messaging: AngularFireMessaging,
    private translate: TranslateService,
    private http: HttpClient
  ) {}

  async requestPermission() {
    if (this.permissionRequested) return;

    try {
      await this.messaging.requestPermission.toPromise();
      this.permissionRequested = true;

      const token = await this.getToken();
      if (token && token !== this.token) {
        this.token = token;
        await this.subscribeToTopic(token, 'all');
        await this.updateTokenOnServer(token, 'all');
      }

    } catch (err) {
      console.log('Permission denied or token error', err);
      console.log(err);
    }
  }

  getToken(): Promise<string | null> {
    return new Promise((resolve, reject) => {
      this.messaging.getToken.subscribe({
        next: (token) => token ? resolve(token) : reject('No token available'),
        error: (err) => reject(err)
      });
    });
  }

  subscribeToTopic(token: string, topic: string) {
    let lang = localStorage.getItem('selectedLanguage');
    if (lang) {
      this.translate.use(lang);
      this.currentLanguage = lang;
    }

    const url = `${environment.baseUrl}/subscribe-topic?token=` + token + '&topic=' + topic + '&lang=' + this.currentLanguage;
    return fetch(url, {
      method: 'GET',
    });
  }

  updateTokenOnServer(token: string, topic: string): Promise<any> {
    let lang = localStorage.getItem('selectedLanguage');
    if (lang) {
      this.translate.use(lang);
      this.currentLanguage = lang;
    }

    const url = `${environment.baseUrl}/subscribe-topic?token=` + token + '&topic=' + topic + '&lang=' + this.currentLanguage;

    return fetch(url, {
      method: 'GET',
    });
  }
}
